import action from "../action";
export const SET_LT_COUNTDOWN = "SET_LT_COUNTDOWN";
export const SET_CC_COUNTDOWN = "SET_CC_COUNTDOWN";
export const SET_QUESTION = "SET_QUESTION";
export const SET_CAPTION = "SET_CAPTION";
export const SET_ANSWERS = "SET_ANSWERS";
export const SET_CORRECT_ANSWER = "SET_CORRECT_ANSWER";
export const RESET_LTS_STATE = "RESET_LTS_STATE";
export const SET_CC_VOTE = "SET_CC_VOTE";
export const SET_LT_QUESTION = "SET_LT_QUESTION";
export const SET_HAS_ANSWERED = "SET_HAS_ANSWERED";
export const SET_TTL_MODAL_OPEN = "SET_TTL_MODAL_OPEN";
export const SET_TTL_TRUTHS = "SET_TTL_TRUTHS";
export const SET_TTL_LIE = "SET_TTL_LIE";
export const SET_TTL_GUESSER = "SET_TTL_GUESSER";
export const SET_TTL_USERS_LIST = "SET_TTL_USERS_LIST";
export const SET_TTL_USER_SCORE = "SET_TTL_USER_SCORE";
export const SET_TTL_PLAYERS_ARRAY = "SET_TTL_PLAYERS_ARRAY";

export const set_lt_countdown = (data) =>
  action({
    type: SET_LT_COUNTDOWN,
    data,
  });

export const set_lt_question = (data) =>
  action({
    type: SET_LT_QUESTION,
    data,
  });

export const set_question = (data) =>
  action({
    type: SET_QUESTION,
    data,
  });

export const set_answers = (data) =>
  action({
    type: SET_ANSWERS,
    data,
  });

export const set_correct_answer = (data) =>
  action({
    type: SET_CORRECT_ANSWER,
    data,
  });

export const reset_lts_state = () =>
  action({
    type: RESET_LTS_STATE,
  });

export const set_caption = (data) =>
  action({
    type: SET_CAPTION,
    data,
  });

export const set_cc_countdown = (data) =>
  action({
    type: SET_CC_COUNTDOWN,
    data,
  });

export const set_cc_vote = (data) =>
  action({
    type: SET_CC_VOTE,
    data,
  });

export const set_has_answered = (data) =>
  action({
    type: SET_HAS_ANSWERED,
    data,
  });

export const set_ttl_modal_open = (data) =>
  action({
    type: SET_TTL_MODAL_OPEN,
    data,
  });

export const set_ttl_truths = (data) =>
  action({
    type: SET_TTL_TRUTHS,
    data,
  });

export const set_ttl_lie = (data) =>
  action({
    type: SET_TTL_LIE,
    data,
  });

export const set_ttl_guesser = (data) =>
  action({
    type: SET_TTL_GUESSER,
    data,
  });

export const set_ttl_users_list = (data) =>
  action({
    type: SET_TTL_USERS_LIST,
    data,
  });

export const set_ttl_user_score = (data) =>
  action({
    type: SET_TTL_USER_SCORE,
    data,
  });

export const set_ttl_players_array = (data) =>
  action({
    type: SET_TTL_PLAYERS_ARRAY,
    data,
  });
